var map = {
	"./calculator-aki-onco/background_points": 3,
	"./calculator-aki-onco/background_points.svg": 3,
	"./calculator-aki-onco/darts": 4,
	"./calculator-aki-onco/darts.svg": 4,
	"./calculator-aki-onco/logo_ge": 5,
	"./calculator-aki-onco/logo_ge.svg": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;